import {
  EducationLevelType,
  LegalClientFinancialInstrumentType,
} from 'api/types/entity';
import { isYes, yesOrNotSelectValidation } from 'helpers';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
  selectSchema,
  array,
  string,
} from 'libs/form';
import { Maybe } from 'types/maybe';
import { SelectType } from 'types/selectType';
import { YesOrNoSelectType } from 'types/yesOrNo';

export interface KnowledgeAndExperienceFormType {
  knowledgeAndExperience?: {
    educationLevel?: Maybe<SelectType<EducationLevelType>>;
    financialInstruments?: Maybe<
      SelectType<LegalClientFinancialInstrumentType>[]
    >;
    hasQualifiedOfficersForInvestmentDecisions: Maybe<YesOrNoSelectType>;
    heldFinancialPositionInLast5Years?: Maybe<YesOrNoSelectType>;
    otherFinancialInstrument?: string;
  };
}

const isOtherFinancialInstruments = (
  values?: SelectType<LegalClientFinancialInstrumentType>[]
) =>
  values?.find((v) => v?.value === LegalClientFinancialInstrumentType.Other) !==
  undefined;

export const getKnowledgeAndExperienceSchema =
  (): ObjectSchema<KnowledgeAndExperienceFormType> =>
    object({
      knowledgeAndExperience: object({
        hasQualifiedOfficersForInvestmentDecisions: yesOrNotSelectValidation
          .default(null)
          .required(),

        financialInstruments: array()
          .of(
            selectSchema(
              Object.values(LegalClientFinancialInstrumentType)
            ).required()
          )
          .default(null)
          .nullable(),

        otherFinancialInstrument: string().when('financialInstruments', {
          is: isOtherFinancialInstruments,
          then: (schema) => schema.required().max(200),
        }),

        educationLevel: selectSchema(Object.values(EducationLevelType))
          .when('hasQualifiedOfficersForInvestmentDecisions', {
            is: isYes,
            then: (schema) => schema.required(),
            otherwise: (schema) => schema.nullable(),
          })
          .default(null),

        heldFinancialPositionInLast5Years: yesOrNotSelectValidation
          .when('hasQualifiedOfficersForInvestmentDecisions', {
            is: isYes,
            then: (schema) => schema.required(),
            otherwise: (schema) => schema.nullable(),
          })
          .default(null),
      }),
    });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<KnowledgeAndExperienceFormType>();

export type FormErrors = FormErrorsBase<KnowledgeAndExperienceFormType>;
